module.exports = __webpack_public_path__ + "img/dashboard-icon4.a4fa61fd.svg";